import { render, staticRenderFns } from "./SaleImportTax.vue?vue&type=template&id=29245fa6&scoped=true"
import script from "./SaleImportTax.vue?vue&type=script&lang=js"
export * from "./SaleImportTax.vue?vue&type=script&lang=js"
import style0 from "./SaleImportTax.vue?vue&type=style&index=0&id=29245fa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29245fa6",
  null
  
)

export default component.exports